import { render } from "./bmsAddTask.vue?vue&type=template&id=53971f7b"
import script from "./bmsAddTask.vue?vue&type=script&lang=js"
export * from "./bmsAddTask.vue?vue&type=script&lang=js"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__